import dayjs from "dayjs";

import { STORAGE_KEYS } from "@/restricted-library/constants/storage";

import {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES
} from "@/restricted-library/locales";

function isSupported(locale) {
  return SUPPORTED_LOCALES.some(l => l.code === locale);
}

export function getLanguage() {
  const locale = window.localStorage.getItem(STORAGE_KEYS.LANGUAGE);
  return isSupported(locale) ? locale : DEFAULT_LOCALE;
}

export function changeLanguage(locale) {
  if (!isSupported(locale)) {
    locale = DEFAULT_LOCALE;
  }
  dayjs.locale(locale);
  window.localStorage.setItem(STORAGE_KEYS.LANGUAGE, locale);
}
